import { dataFullscreenExit } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFullscreenExit = /*#__PURE__*/createIcon(dataFullscreenExit)
export default IconFullscreenExit
